module.exports = __webpack_public_path__ + "static/media/Reiniciar.322ef5b9.svg";